module.exports = __webpack_public_path__ + "static/img/logo.1b93e4a7.png";